<div class="container">
 
    <div id="details" class="clearfix">
      <div id="client">
        <div class="to">PEDIDO A:</div>

        <label for="producto">Cliente</label>

        {{ nombre_cliente }}

        <div class="address">
          <br />
          <label>NIT/CI: {{ nit }}</label>
        </div>
        <div class="email">
          <label>Direccion: {{ direccion }}</label>
        </div>
      </div>
      <div id="invoice">
        <h1>PROFORMA - {{ proforma_id }}</h1>
        <div class="date">
          Fecha de proforma:
          {{ fecha_pedido }}
        </div>
        <div class="date">
          Fecha de Vencimiento:
          <input type="date" [(ngModel)]="fecha_entrega" class="form-control" />
        </div>
      </div>
    </div>
    <div class="card-header">
      <i class="fas fa-users text-success"></i> Detalles:
      <a
        class="btn  bg-primary  text-white"
        style="cursor: pointer;"
        (click)="nuevoProducto()"
        >+
        <i class="fas fa-user-plus text-purple"></i>
      </a>
    </div>
    <br />

    <form [formGroup]="form" novalidate (ngSubmit)="save(form.value)">

      <table class="table">
        <div formArrayName="credentials">
        <tr>
          <th># </th>
          <th colspan="4">DESCRIPCION </th>
          <th>UNID </th>
          <th>CANT </th>
          <th>STOCK </th>
          <th>COSTO </th>
          <th>PREC. </th>
          <th>TOTAL </th>
          <th>#</th>
        </tr>
        
        <tr  *ngFor="let creds of formData.controls; let i = index"
        [formGroupName]="i" >
          <td style="width: 5px;"
            class="col-md-1"
            [ngStyle]="
              !(
                creds.controls['cantidad'].value <=
                creds.controls['stock'].value
              )
                ? { 'background-color': '#fcbbc5' }
                : { 'background-color': 'white' }
            "
          >
            {{ i + 1  }}
          </td>
          <td colspan="4">
            <ng-select
              bindLabel="name"
              placeholder="Selecionar Producto"
              [searchable]="true"
              (change)="getSelectedProduct($event, i)"
              formControlName="nombre_producto"
            >
              <ng-option [value]="item" *ngFor="let item of products">
                {{ item.nombre_producto }}
              </ng-option>
            </ng-select>

          </td>
          <td>
            <input type="text" class="form-control form-control-sm" formControlName="unidad" />

          </td>
          <td>
            <input
              type="number"
              class="form-control form-control-sm"
              formControlName="cantidad"
            />

          </td>
          <td *hasPermission="['administrador', 'almacen']"   >
            <input type="text" disabled class="form-control form-control-sm" formControlName="stock" />
          </td>
          <td *hasPermission="['administrador', 'almacen']"   >
            <input type="text" class="form-control form-control-sm" formControlName="costo" />
          </td>
          <td>
            <input  [style.background-color]="creds.get('precio').value< creds.get('costo').value?'red':'white'"
              type="number"
              placeholder="PRECIO"
              class="form-control form-control-sm"
              formControlName="precio"
            />

          </td>
          <td>
            <input
              type="text"
              class="form-control form-control-sm"
              formControlName="totalUnitPrice"
            />
          </td>
          <td>
            <a class="btn btn-danger" (click)="eliminarProducto(i)"> x</a>
          </td>
        </tr>
      </div>
      </table>

  
        <div class="row">
          <div class="col-md-11 text-right ">
            <h4>
              TOTAL: {{ totalSum | currency: 'BOB':'symbol-narrow':'1.2-2' }}
            </h4>
          </div>
        </div>
        <strong>
          <label for="">Vendedor:</label>
          {{ nombre_vendedor }}</strong
        >



      <div class="row">
        <div class="col-md-3">
          Tipo de pago:
          <select formControlName="pago" class="form-control" name="valueCheck">
            <option *ngFor="let obj of cancelacion" [ngValue]="obj.name">
              {{ obj.name }}
            </option>
          </select>
        </div>
      </div>
      <br />
      <div class="row text-center">
        <div class="col-md-12">
          <button
            class="btn btn-warning btn-lg btn-block text-uppercase waves-effect waves-light"
            [disabled]="form.invalid || isLoading"
          >
            <app-button-loader
              [isLoading]="isLoading"
              [label]="'Modificar Proforma'"
            ></app-button-loader>
          </button>
        </div>
      </div>
    </form>
    
    
 
  <footer>
    Distribuidor PAPERLIFE
  </footer>
</div>

